// extracted by mini-css-extract-plugin
module.exports = {"ORDER_ASSIGN":"ORDER_ASSIGN-764a6ecf70bebf0b6e6eba9dac96ded9","ORDER_ASSIGN-form":"ORDER_ASSIGN-form-b505b6abe6c5dc8c59072ecc5094b003"};